class MetafieldVariantSelector extends HTMLElement {
  constructor() {
    super();
    console.log('MetafieldVariantSelector initialized for:', this);
    
    // Wait for the element to be connected to the DOM
    if (this.isConnected) {
      this.init();
    } else {
      this.addEventListener('connectedcallback', this.init.bind(this));
    }
  }

  connectedCallback() {
    console.log('Connected callback fired for MetafieldVariantSelector');
    this.init();
  }

  init() {
    console.log('Initializing MetafieldVariantSelector');
    this.variantButtons = this.querySelectorAll('button.product_pill_links:not(.disabled)');
    console.log('Found variant buttons:', this.variantButtons.length);
    this.bindEvents();
  }

  bindEvents() {
    console.log('Binding events to buttons');
    this.variantButtons.forEach((button) => {
      console.log('Adding click listener to button:', button.textContent.trim(), 'Handle:', button.dataset.handle);
      button.addEventListener('click', this.onVariantChange.bind(this));
    });
  }

  onVariantChange(event) {
    console.log('Button clicked:', event.currentTarget);
    const button = event.currentTarget;
    const handle = button.dataset.handle;
    const variantType = this.dataset.variantType;
    const sectionId = this.dataset.sectionId || this.dataset.section;
    
    console.log('Variant change details:', {
      handle,
      variantType,
      sectionId,
      isCurrentProduct: button.hasAttribute('aria-current')
    });

    // If it's the current product, do nothing
    if (button.hasAttribute('aria-current')) {
      console.log('This is the current product, doing nothing');
      return;
    }

    // Direct navigation is more reliable - let's use it as our default approach
    console.log('Navigating to product page:', `/products/${handle}`);
    window.location.href = `/products/${handle}`;
    return;

    // Code below is kept for debugging but not executed
    // Show loading state
    document.body.classList.add('loading');
    
    // Use Shopify's Section Rendering API to fetch the new product
    const url = `/products/${handle}?section_id=${sectionId}`;
    console.log('Fetching product from URL:', url);
    
    fetch(url)
      .then(response => {
        console.log('Received response:', response);
        return response.text();
      })
      .then(responseText => {
        console.log('Received response text of length:', responseText.length);
        // Create a temporary element to hold the fetched HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;
        
        // First try to find the section directly - Shopify Section Rendering API usually returns just the section
        let newContent = tempDiv.querySelector(`#MainProduct-${sectionId}`);
        console.log('Looking for product section with ID:', `MainProduct-${sectionId}`);
        
        if (!newContent) {
          // Fallback: try to find product-info tag
          console.log('Fallback: Looking for product-info element');
          newContent = tempDiv.querySelector('product-info');
        }
        
        console.log('Found new content:', newContent);
        
        if (newContent) {
          // Find the target to update
          const currentProductSection = document.querySelector('product-info');
          console.log('Found current product section:', currentProductSection);
          
          if (currentProductSection) {
            console.log('Replacing product section HTML');
            // If we're fetching a full section with the product-info tag
            if (newContent.tagName === 'PRODUCT-INFO') {
              currentProductSection.innerHTML = newContent.innerHTML;
            } else {
              // If we're fetching just the section content
              currentProductSection.innerHTML = newContent.outerHTML;
            }
            
            // Update URL in browser history without reloading
            history.pushState({ path: `/products/${handle}` }, '', `/products/${handle}`);
            
            // Reinitialize any necessary JavaScript components
            this.reInitializeComponents();
          } else {
            console.error('Could not find current product-info element to update');
            // Fall back to traditional navigation
            window.location.href = `/products/${handle}`;
          }
        } else {
          console.error('Could not find content in fetched HTML');
          console.log('First 500 characters of response:', responseText.substring(0, 500));
          // Fall back to traditional navigation
          window.location.href = `/products/${handle}`;
        }
      })
      .catch(e => {
        console.error('Error loading product:', e);
        // Fall back to traditional navigation
        console.log('Falling back to traditional navigation to:', `/products/${handle}`);
        window.location.href = `/products/${handle}`;
      })
      .finally(() => {
        // Remove loading state
        document.body.classList.remove('loading');
      });
  }

  reInitializeComponents() {
    console.log('Reinitializing components');
    // Reinitialize variant selectors
    if (window.VariantSelects) {
      const variantSelects = document.querySelectorAll('variant-selects');
      console.log('Found variant selects to reinitialize:', variantSelects.length);
      variantSelects.forEach(selector => {
        new window.VariantSelects(selector);
      });
    } else {
      console.warn('VariantSelects not available on window object');
    }
    
    // Reinitialize quantity inputs
    if (window.QuantityInput) {
      const quantityInputs = document.querySelectorAll('quantity-input');
      console.log('Found quantity inputs to reinitialize:', quantityInputs.length);
      quantityInputs.forEach(input => {
        new window.QuantityInput(input);
      });
    } else {
      console.warn('QuantityInput not available on window object');
    }
  }
}

customElements.define('metafield-variant-selector', MetafieldVariantSelector);

// Initialize all metafield variant selectors on page load
window.addEventListener('DOMContentLoaded', () => {
  console.log('DOM content loaded, initializing metafield variant selectors');
  const selectors = document.querySelectorAll('.metafield-variants');
  console.log('Found metafield variants to initialize:', selectors.length);
  selectors.forEach(selector => {
    selector.classList.add('metafield-variant-selector');
    new MetafieldVariantSelector(selector);
  });
}); 